import { IPersona } from "../types";

export const personasData: IPersona[] = [
    {
        id: 0,
        name: "Video Games",
        icon: "games",
        isSelected: false,
        categories: [
            {
                id: 0,
                name: "Game 1",
                icon: "games",
                isSelected: false,
            },
            {
                id: 1,
                name: "Game 2",
                icon: "games",
                isSelected: false,
            },
            {
                id: 2,
                name: "Game 3",
                icon: "games",
                isSelected: false,
            },
            {
                id: 3,
                name: "Game 4",
                icon: "games",
                isSelected: false,
            },
            {
                id: 4,
                name: "Game 5",
                icon: "games",
                isSelected: false,
            },
            {
                id: 5,
                name: "Game 6",
                icon: "games",
                isSelected: false,
            },
        ]
    },
    {
        id: 1,
        name: "Sports",
        icon: "sports",
        isSelected: false,        
        categories: [
            {
                id: 0,
                name: "Sport 1",
                icon: "sports",
                isSelected: false,
            },
            {
                id: 1,
                name: "Sport 2",
                icon: "sports",
                isSelected: false,
            },
            {
                id: 2,
                name: "Sport 3",
                icon: "sports",
                isSelected: false,
            },
            {
                id: 3,
                name: "Sport 4",
                icon: "sports",
                isSelected: false,
            },
        ]
    },
    {
        id: 2,
        name: "Entertainment",
        icon: "entertainment",
        isSelected: false,
        categories: [
            {
                id: 0,
                name: "Entertainment 1",
                icon: "games",
                isSelected: false,
            },
            {
                id: 1,
                name: "Entertainment 2",
                icon: "games",
                isSelected: false,
            },
        ]
    },
    {
        id: 3,
        name: "Music",
        icon: "music",
        isSelected: false,
        categories: [
            {
                id: 0,
                name: "Music 1",
                icon: "games",
                isSelected: false,
            },
            {
                id: 1,
                name: "Music 2",
                icon: "games",
                isSelected: false,
            },
        ]
    },
    {
        id: 4,
        name: "Fitness",
        icon: "fitness",
        isSelected: false,
        categories: [
            {
                id: 0,
                name: "Fitness 1",
                icon: "games",
                isSelected: false,
            },
            {
                id: 1,
                name: "Fitness 2",
                icon: "games",
                isSelected: false,
            },
        ]
    },
    {
        id: 5,
        name: "Hobbies",
        icon: "hobbies",
        isSelected: false,
        categories: [
            {
                id: 0,
                name: "Hobbie 1",
                icon: "games",
                isSelected: false,
            },
            {
                id: 1,
                name: "Hobbie 2",
                icon: "games",
                isSelected: false,
            }
        ]
    }
]
